import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export const Hr = styled.hr`
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles?.elements?.underline)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles?.elements?.underline)}
`;
